import React from 'react';
import { Paper, InputBase, IconButton, CircularProgress } from '@mui/material';
import { Search } from '@mui/icons-material';
import PropTypes from 'prop-types';

const CustomizedInputBase = ({
  handleClick,
  isSubmitting,
  field,
  aria,
  form: { touched, errors },
  ...rest
}) => {
  const classes = {
    iconButton: {
      padding: 0.5,
    },
  };

  return (
    <Paper
      sx={{
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <InputBase
        className={classes.input}
        sx={{ marginLeft: 1, flex: 1 }}
        {...field}
        {...rest}
        inputProps={{ 'aria-label': { aria } }}
      />
      <IconButton
        onClick={handleClick}
        sx={classes.iconButton}
        aria-label={aria}
      >
        {isSubmitting ? <CircularProgress size={28} /> : <Search />}
      </IconButton>
      {touched[field.name] && errors[field.name] && (
        <div className="error">{errors[field.name]}</div>
      )}
    </Paper>
  );
};

CustomizedInputBase.defaultProps = {
  isSubmitting: false,
};

CustomizedInputBase.propTypes = {
  handleClick: PropTypes.func.isRequired,
  field: PropTypes.oneOfType([PropTypes.any]).isRequired,
  form: PropTypes.oneOfType([PropTypes.any]).isRequired,
  isSubmitting: PropTypes.bool,
  aria: PropTypes.string.isRequired,
};

export default CustomizedInputBase;
